import React from 'react';
import { WhatsappIcon } from '../Svg';
import './WhatsappBtn.css'
import { tagOnWhatsappButtonClick } from 'src/Tagging/SalesTagging';

function WhatsappBtn() {

  const whatsappUs = (e) => {

    e.preventDefault();
    tagOnWhatsappButtonClick();
    window.open('https://api.whatsapp.com/send/?phone=27826223509', '_blank');
  };

  return (
    <div className="whatsappbtn-wrapper">
      <button className="whatsappbtn" onClick={whatsappUs}>
        <span className="whatsapp-mobile-hide-icon">
          <WhatsappIcon />
        </span>
        WhatsApp us
      </button>
    </div>
  );
}

export default WhatsappBtn;
